export const LOGIN_USER ="LOGIN_USER";

export const LOGOUT_USER = "LOGOUT_USER"

